import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldlayoutsCopyRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-copy',
	path: '/secure/admin/CopyFieldLayout!default.jspa',
};
